import React from 'react';
import {get} from 'lodash';

import SectionHeader from '/component/base/SectionHeader';
import {withTranslation} from '/provider/TranslationProvider';
import {generateComponentCallback} from '/util/component.util';

interface LoadingData {
  total: number;
}

interface ReportMeta {
  page: {
    total: number;
  };
}

interface CandidatesListHeaderProps {
  tt: (key: string, options?: any) => string;
  loadingData: LoadingData | null;
  reportMeta: ReportMeta | null;
  reportName: string;
  reportIsLoading: boolean;
}

export const CandidatesListHeader: React.FC<CandidatesListHeaderProps> = ({
  tt = withTranslation.ttDefaultProp,
  loadingData = null,
  reportMeta = null,
  reportName = '',
  reportIsLoading = true,
}) => {
  let total = get(reportMeta, 'page.total', get(loadingData, 'total', ''));
  return (
    <SectionHeader
      reportName={reportName}
      reportIsLoading={reportIsLoading}
      reportMeta={reportMeta}
      allowFontScaling
      maxFontSizeMultiplier={2}>
      {tt(
        'totalCandidatesCount',
        generateComponentCallback({
          component: (
            <>
              {total} {total == 1 ? 'Contact' : 'Contacts'}
            </>
          ),
        }),
      )}
    </SectionHeader>
  );
};

export default withTranslation('report.list.candidatesHeader')(
  CandidatesListHeader,
);
